import { useLang } from "@/context/LanguageContext";
import { SectionHead } from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/assets";

export const Wall = () => {
  const { t } = useLang();
  const w = t.wall;
  return (
    <section id="wall" className="py-20 md:py-28 bg-surface" data-testid="wall-section">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8">
        <SectionHead label={w.label} title={w.title} subtitle={w.body} />
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-tricolor-green mb-6">{w.kicker}</p>
            <div className="grid sm:grid-cols-2 gap-5">
              {w.features.map((f, i) => (
                <div key={i} className="card p-6 hover:-translate-y-1 hover:shadow-[0_16px_40px_-20px_rgba(0,0,0,0.2)]" data-testid={`wall-feature-${i}`}>
                  <span className="w-9 h-9 rounded-full bg-tricolor-green text-white flex items-center justify-center font-display font-bold">{f.n}</span>
                  <h3 className="mt-4 font-display font-bold text-lg text-ink">{f.title}</h3>
                  <p className="mt-2 text-sm text-muted leading-relaxed">{f.body}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-[2rem] border border-line shadow-[0_30px_80px_-30px_rgba(0,0,0,0.25)] h-[55vh] md:h-[68vh]">
              <img src={IMAGES.foodboxWall} alt="Food-Box Wall" loading="lazy" decoding="async" className="w-full h-full object-cover" data-testid="wall-image" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
